import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import styled from "styled-components";
import tw from "twin.macro";

const OutlineText = styled.span`
    z-index: -1;

    ${tw`text-gray-200 text-[5.6rem] leading-[0]  md:text-[7rem ] lg:text-[9rem]`}
`;

const SubTitle = styled.p`
    ${tw`relative text-3xl tracking-tighter sm:text-4xl font-semibold !leading-snug md:text-4xl lg:text-5xl text-center`};
`;
const IntroduceOverview = () => {
    return (
        <div className="container mx-auto max-w-6xl px-6 py-10">
            {/* <h1 className=" text-3xl font-semibold capitalize text-gray-800 dark:text-white lg:text-4xl xl:text-5xl">
                About <span className="text-brand ">KUSRC</span>
            </h1> */}
            {/* <div className="lg:-mx-6 lg:flex lg:items-center lg:justify-center">
                <img
                    className="h-full w-full object-contain  object-center lg:mx-6 lg:h-[36rem] lg:w-1/2"
                    src="/img/introduce-01.png"
                    alt=""
                />
                <div className=" mt-8 lg:mt-0 lg:w-1/2 lg:px-6">
                     <p className="text-5xl font-semibold text-brand-light ">“</p>
                    <h1 className="text-2xl font-bold leading-normal text-gray-600 dark:text-white  xl:text-4xl">
                        케이유융합소프트웨어연구센터는 <br />
                        <span className="underline decoration-red-500">
                            ICT융합기술
                        </span>
                        을 지속적으로 연구해왔으며, <br />
                        현재
                        <span className="underline decoration-red-500">
                            ICT융합기술사업화, Digital Transformation
                        </span>
                        및 <br />
                        <span className="underline decoration-red-500">
                            서비스 인큐베이팅
                        </span>
                        을 통해 <br />
                        4차산업혁명을 선도하고자 합니다.
                    </h1>
                </div>
            </div> */}
            <div className="mt-12 flex flex-col text-gray-900">
                <div className="flex items-center justify-center gap-6 sm:gap-12">
                    <img
                        className="h-20 w-20 object-contain sm:h-28 sm:w-28"
                        src="/img/salesforce_partner_badge.png"
                        alt="Salesforce Partner"
                    />
                    <img
                        className="h-20 w-20 object-contain sm:h-28 sm:w-28"
                        src="/img/databricks/databricks_partner_badge.svg"
                        alt="Databricks Brickbuilder Partner Network Bronze"
                    />
                    <img
                        className="h-20 w-20 object-contain sm:h-28 sm:w-28"
                        src="/img/snowflake_partner_badge.png"
                        alt="Snowflake Services Partner Select"
                    />
                </div>

                <div className=" mt-5 flex  flex-col items-center justify-center  align-middle tracking-tight">
                    {/*<SubTitle>*/}
                    {/*    Salesforce Consulting & <br className="md:hidden"/>Agentforce Certified &*/}
                    {/*    <br />*/}
                    {/*    Snowflake AI Data Cloud Services*/}
                    {/*</SubTitle>*/}
                    <p className="mt-6 max-w-4xl text-center text-body leading-relaxed">
                        케이유융합소프트웨어연구센터(KUSRC)는 공식 Salesforce 및
                        Databricks Partner로서 기업의 성공적인 클라우드 혁신을
                        지원합니다. Salesforce를 통한 고객 경험 개선과 Agentforce
                        기반 AI 자동화를 넘어, Databricks를 중심으로 데이터
                        통합·분석부터 AI까지 연결되는 지능형 데이터 환경을
                        구축합니다. 또한 다양한 데이터 플랫폼과의 연계를 통해
                        기업의 데이터 활용도를 높이고, 데이터에서 새로운 비즈니스
                        가치를 창출할 수 있도록 지원합니다.
                    </p>

                    <Link
                        to="/databricks"
                        className="mt-5  flex w-fit items-center border-b-2 border-transparent text-gray-500 transition duration-300 duration-300 hover:border-brand hover:text-brand"
                    >
                        <ArrowRightIcon className="mr-1 h-5 w-5" /> 더 알아보기
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default IntroduceOverview;
